import { routeFactory } from '@rtls/core/models/convoy/route.factory';
import { Route } from '@rtls/core/models/convoy/route.model';
import { stopTimeFactory } from '@rtls/core/models/convoy/stop-time.factory';
import { StopTime } from '@rtls/core/models/convoy/stop-time.model';
import { random, randomName, randomNumber, randomSizeList } from '@rtls/map/util/factory/factory.util';
import * as Factory from 'factory.ts';

export const tripFactory = Factory.makeFactory<Trip>({
	shortName: Factory.each(() => randomName()),
	route: Factory.each(() => routeFactory.build()),
	stopTimes: Factory.each(() => randomStopTimes()),
});

function randomStopTimes(): StopTime[] {
	const stopTimes = randomSizeList(
		() => stopTimeFactory.build(),
		10,
		(size) => size > 2 || random(40),
	);
	const maxLength = randomNumber() * 1000;
	const stopNumbers = stopTimes.length;
	for (let i = 0; i < stopNumbers; i++) {
		const distanceRatio = maxLength / stopNumbers;
		stopTimes[i].stopSequence = i;
		stopTimes[i].shapeDistanceTraveled = i * distanceRatio + (i - 1) * randomNumber() * distanceRatio;
		if (i === stopNumbers - 1) {
			stopTimes[i].shapeDistanceTraveled = maxLength;
		}
	}
	return stopTimes;
}

export class Trip {
	route: Route;
	shortName: string;
	stopTimes: StopTime[];
}
